export const IMAGES_UPLOAD_SET = 'IMAGES_UPLOAD_SET'
export const IMAGES_UPLOAD_RESET = 'IMAGES_UPLOAD_RESET'